// Fallback constants for Timeline component
export const TIMELINE_DATE_TYPE_OPTIONS = [
  'Baseline Start Date',
  'Baseline End Date',
  'Actual Start Date',
  'Replanned End Date',
];


export const TIMELINE_STATUS_OPTIONS = ['Approved', 'Rejected', 'Draft', 'Open'];

export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_LIMITS = [10, 25, 50];
